import { Controller } from '@hotwired/stimulus';

// Connects to data-controller="dialog"
export default class extends Controller {
  static targets = ['dialog'];

  open(event) {
    event.preventDefault();
    this.dialogTarget.showModal();
  }

  close(event) {
    event?.preventDefault();
    this.dialogTarget.close();
  }

  closeOnBackdrop(event) {
    if (event.target === this.dialogTarget) {
      this.close();
    }
  }
}
